<template>
  <div v-if="isShowProductModal" class="jquery-modal blocker current" style="opacity: 1;">
    <div id="productAddedModal" aria-hidden="true" class="modal" role="dialog" style="opacity: 1; display: inline-block;"
         tabindex="-1">
      <button class="modal__close" data-close-modal type="button" @click="() => isShowProductModal = false">
        <img alt="" src="/shop/images/modal-close.svg">
      </button>

      <div class="modal__header">
        <h2 class="modal__title  text-center">{{ in18['modal_title'] }}</h2>
      </div>

      <div class="modal__content">
        <table class="cart  cart--modal">
          <thead>
          <tr>
            <th>{{ in18['modal_cart_item_product'] }}</th>
            <th>{{ in18['modal_cart_item_quantity'] }}</th>
            <th>{{ in18['modal_cart_item_price'] }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in cart.items">
            <template v-if="item.product.type === 'product'">
              <td>
                <div class="cart__prod-info">
                  <div class="cart__prod-photo">
                    <a :href="item.product.link" :title="item.product.title">
                      <picture>
                        <source :srcset="item.product.image.webp" type="image/webp">
                        <img :alt="item.product.title" :src="item.product.image.source" loading="lazy">
                      </picture>
                    </a>
                  </div>
                  <div class="cart__prod-data">
                    <div class="cart__prod-title">{{ item.product.title }}</div>
                  </div>
                </div>
              </td>
              <td>
                {{ item.quantity }}
              </td>
              <td>
                <div>
                  <del v-if="item.coupon_total_price_with_tax > 0" class="old-price">
                    <b class="color-gray">{{ item.formatted_old_price_with_tax }}</b>
                  </del>
                  <!-- Item total price -->
                  <div>
                    <b>{{ item.formatted_total_price_with_tax }}</b>
                  </div>
                </div>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="modal__footer">
        <button class="btn  btn--primary-outline  btn--md" data-close-modal="" type="button"
                @click="() => isShowProductModal = false">{{ in18['modal_summary_continue_shipping'] }}
        </button>
        <a :href="checkout_route" class="btn  btn--red  btn--md">{{ in18['modal_checkout'] }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import CartItemsList from '../components/cart/CartItemsList.vue';

export default {
  name:       "ModalProductAddedToCart",
  components: {
    'cart-items-list': CartItemsList,
  },
  props:      {
    in18:           Object,
    checkout_route: String,
  },
  data() {
    return {
      cart: {},
    }
  },
  computed: {
    isShowProductModal: {
      get: function get() {
        return this.$store.getters.isShowProductModal;
      },
      set: function set(value) {
        this.$store.commit('SET_IS_SHOW_PRODUCT_MODAL', value);
      }
    },
  },
  watch:    {
    isShowProductModal(isShow) {
      if (isShow) {
        this.fetchCart();
      }
    }
  },
  methods:  {
    fetchCart() {
      axios.get('/api/cart')
          .then((response) => {
            this.cart = response.data.cart;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            this.inProgress = false
          });
    },
  }
}
</script>

<style scoped>
.modal__content {
  overflow-y: auto;
  max-height: 333px;
}
</style>
